import { Component } from "@angular/core";
import { Subscription } from "rxjs";
@Component({
    selector: "subscription-removing-component",
    template: ``,
    standalone: true
})
export class SubscriptionsRemovingComponent {
  private subscriptions: Subscription[] = [];
  constructor() {
    this.subscriptions = [];
  }
  ngOnDestroy() {
    this.clearSubscriptions();
  }
  clearSubscriptions() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
  addSubscription(subscription) {
    this.subscriptions.push(subscription);
  }
}
